import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcSave(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 19.493a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5zM11.25 3a.75.75 0 0 1 1.5 0v11.19l2.72-2.72a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06l2.72 2.72z"
  }));
}
var IcSave = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSave));

export { IcSave as I };
